import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, TicketPercent } from "lucide-react";

const PromoBanner = () => (
  <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid="offer-banner">
    <div className="relative overflow-hidden rounded-[8px] border border-cynos-red/40 bg-cynos-red">
      <div className="absolute inset-0 grain" />
      <div className="relative z-10 grid gap-5 px-5 py-6 md:grid-cols-[auto_1fr_auto] md:items-center md:gap-6 md:px-8 lg:px-10">
        <div className="hidden h-14 w-14 items-center justify-center rounded-[8px] bg-black text-white md:flex">
          <TicketPercent size={26} />
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/80">First Order Offer</div>
          <h2 className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none text-white md:text-5xl">
            Get {"\u20b9"}100 OFF on your first order
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-white/85">
            Start with an oversized tee, graphic drop, or anime print and make the first cart count.
          </p>
        </div>
        <Link to="/shop" className="inline-flex min-h-[50px] items-center justify-center gap-2 rounded-[8px] bg-black px-6 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-white transition hover:bg-zinc-900 md:text-xs" data-testid="offer-shop-btn">
          Shop The Offer <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  </section>
);

export default PromoBanner;
